import React, { useEffect, useState } from 'react';
import Create from './Create';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import { t } from 'i18next';
import { DashboardContent } from '@/layouts/dashboard';

export function QuizCreate(props) {
  const { representation, id, uri } = props;

  const client = useClient();
  const [surveyData, setSurveyData] = useState([]);

  useEffect(() => {
    getSurveyData();
  }, []);

  const getSurveyData = async () => {
    const { data, error } = await client.fetch(`surveys/${id}`);
    if (error) {
      toast.error('Erro ao buscar dados do questionário em questão.');
    } else {
      setSurveyData(data);
    }
  };

  const breadcrumbs = {
    title: 'Ferramentas de Avaliação',
    nav: [
      {
        route: '/questionario',
        name: 'Questionário de Percepção',
        isActive: false
      },
      {
        route: uri,
        name: surveyData?.title,
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      className="animate-fade-in"
      style={{ overflow: 'initial' }}
      breadcrumbs={breadcrumbs}
    >
      <div
        className="page"
        style={{ alignItems: 'stretch' }}
      >
        <Create
          representation={representation}
          surveyData={surveyData}
        />

        <aside className="page__aside">
          <div
            className="new-questions__info"
            style={{ top: '90px' }}
          >
            <p>{t('nps.everythingBeingSaving')}</p>
          </div>
        </aside>
      </div>
    </DashboardContent>
  );
}
